import { PublicationShortname } from "@src/app/auth/serviceIdentifier";
import cx from "classnames";
import { ReactElement, useContext } from "react";
import { useTranslation } from "react-i18next";
import AppContext from "src/app/AppContext";

import styles from "./index.module.scss";

type Props = {
  children: ReactElement;
  slideNumber: number;
};

export function OnboardingSlide({
  children,
  slideNumber,
}: Props): ReactElement {
  const { pubId } = useContext(AppContext);
  const { t } = useTranslation();

  return (
    <div className={cx(styles.onboardingSlideContainer)}>
      <div className={cx(styles.imageContainer)}>{children}</div>
      <div className={cx(styles.onboardingInfo)}>
        <p className={cx(styles.onboardingTitle)} data-theme={pubId}>
          {t(`onboarding:tutorials.${slideNumber}.title`)}
        </p>
        <p className={cx(styles.onboardingDescription)} data-theme={pubId}>
          {pubId === PublicationShortname.TABLA && slideNumber == 1
            ? t(`onboarding:tutorials.${slideNumber}.bodyFree`)
            : t(`onboarding:tutorials.${slideNumber}.body`)}
        </p>
      </div>
    </div>
  );
}
